import * as routeApi from "@hub/routes/src/api/routes.api"

const setToast = (type, title) => {
  window.$vue.$toast({ type, title })
}

const handleError = (error, alternativeMessage) => {
  console.error(error)
  setToast("error", error?.response?.data?.message || alternativeMessage)
}

const setSuccessToast = message => {
  setToast("success", message)
}

const getFormatedChild = child => ({ ...child, isSelected: false, layer: null })

const getFormatedChildren = children =>
  children.map(child => getFormatedChild(child))

const getFormatedLayer = layer => ({
  ...layer,
  isOpen: false,
  children: getFormatedChildren(layer.children)
})

const handleFormateLayersTree = response => {
  return response.map(layer => getFormatedLayer(layer))
}

export const listRoutes = async params => {
  try {
    const response = await routeApi.listRoutes(params)
    return response
  } catch (error) {
    handleError(error, "Falha ao requisitar a lista de Rotas")
    throw error
  }
}

export const fetchRoute = async uuid => {
  try {
    return await routeApi.fetchRoute(uuid)
  } catch (error) {
    handleError(error, "Falha ao requisitar as informações da Rota")
    throw error
  }
}

export const fetchMyRoute = async uuid => {
  try {
    const { data } = await routeApi.fetchMyRoute(uuid)
    return data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const createRoute = async data => {
  try {
    const response = await routeApi.createRoute(data)
    setSuccessToast("Rota criada com sucesso")
    return response
  } catch (error) {
    handleError(error, "Falha ao criar a Rota")
    throw error
  }
}

export const editRoute = async data => {
  try {
    const response = await routeApi.editRoute(data)
    setSuccessToast("Rota editada com sucesso")
    return response
  } catch (error) {
    handleError(error, "Falha ao atualizar a Rota")
    throw error
  }
}

export const startRoute = async uuid => {
  try {
    const { data } = await routeApi.startRoute(uuid)
    setSuccessToast("Rota iniciada!")
    return data
  } catch (error) {
    handleError(error, "Falha ao iniciar a Rota.")
    throw error
  }
}

export const pauseRoute = async uuid => {
  try {
    const response = await routeApi.pauseRoute(uuid)
    setSuccessToast("Rota pausada!")
    return response
  } catch (error) {
    handleError(error, "Falha ao pausar a Rota.")
    throw error
  }
}

export const finishRoute = async uuid => {
  try {
    const response = await routeApi.finishRoute(uuid)
    setSuccessToast("Rota finalizada!")
    return response
  } catch (error) {
    handleError(error, "Falha ao pausar a Rota.")
    throw error
  }
}

export const listSellers = async params => {
  try {
    const { data } = await routeApi.listSellers(params)
    return data.users
  } catch (error) {
    handleError(error, "Falha ao obter Vendedores.")
  }
}

export const listStatuses = async () => {
  try {
    const data = await routeApi.listStatuses()
    return data
  } catch (error) {
    handleError(error, "Falha ao obter Status.")
    throw error
  }
}

export const listUsers = async params => {
  try {
    const { data } = await routeApi.listUsers(params)
    return data
  } catch (error) {
    handleError(error, "Falha ao obter Usuários.")
  }
}

export const listLayersTree = async () => {
  try {
    const data = await routeApi.listLayersTree().then(({ data }) => {
      return handleFormateLayersTree(data)
    })
    return data
  } catch (error) {
    handleError(error, "Falha ao obter Camadas.")
    throw error
  }
}

export const fetchRouteDetail = async uuid => {
  try {
    const { data } = await routeApi.fetchRouteDetail(uuid)
    return data
  } catch (error) {
    handleError(error, "Falha ao obter detalhes da Rota.")
    throw error
  }
}

export const fetchLayer = async params => {
  try {
    const { data } = await routeApi.fetchLayer(params)
    return data
  } catch (error) {
    handleError(error, "Falha ao obter dados da Camada.")
    throw error
  }
}

export const fetchIndicatorsDashboard = async params => {
  try {
    const { data } = await routeApi.fetchIndicatorsDashboard(params)
    return data
  } catch (error) {
    handleError(error, "Falha ao buscar as informações dos indicadores")
    throw error
  }
}

export const fetchRolesUser = async params => {
  try {
    const { data } = await routeApi.fetchRolesUser(params)
    return data
  } catch (error) {
    handleError(error, "Falha ao obter os perfis do usuário e os usuários.")
    throw error
  }
}
